/* custom-variant-availability.js — cross out sold-out option values
 *
 * Dawn crosses out an option value only when the combination DOES NOT EXIST. A
 * combination that exists and is out of stock is left looking selectable, and
 * the shopper only finds out after clicking it.
 *
 * On Karate Kicks with Black chosen, S was struck through (there is no S/Black
 * at all) while XL looked fine — XL/Black exists and has zero stock. Same
 * treatment for both is what a customer expects: if you cannot buy it, it should
 * look like you cannot buy it.
 *
 * Applies to every product with options, not just this one, so a size or weight
 * selling out anywhere is struck through without anyone touching the theme.
 *
 * Uses the classes Dawn already uses — `disabled` on pill radios,
 * `visually-disabled` on swatches — so the styling is the theme's own and stays
 * correct if the theme is restyled.
 */
(function () {
  'use strict';

  var cache = {};

  // The product this picker belongs to — never whatever the address bar says.
  //
  // custom-bundle-swap.js rewrites location.pathname to the bundle's URL when a
  // bundle is selected, while leaving the base product's option pills on screen.
  // Reading pathname first therefore fetched the BUNDLE's variants, whose
  // options ("Default Title") match no weight, so buyable() answered false for
  // every pill and the whole picker was struck through — 26 of 26 on Rubber Hex
  // instead of the 11 that are genuinely sold out.
  //
  // The canonical link is not touched by the swap, so it still names the product
  // whose pills these are. Resolved once and remembered: the first call happens
  // at load, before any bundle can be clicked, so even a page with no canonical
  // tag locks on to the right handle.
  var pageHandle = null;
  function handle() {
    if (pageHandle) return pageHandle;
    var c = document.querySelector('link[rel="canonical"]');
    if (c) {
      var m2 = c.href.match(/\/products\/([^/?#]+)/);
      if (m2) { pageHandle = m2[1]; return pageHandle; }
    }
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (m) { pageHandle = m[1]; return pageHandle; }
    return null;
  }

  // A fieldset per option, in the same order as variant.options.
  function groups(vs) {
    return Array.prototype.map.call(vs.querySelectorAll('fieldset, .product-form__input--dropdown'), function (g) {
      var sel = g.querySelector('select');
      return {
        el: g,
        select: sel,
        inputs: Array.prototype.slice.call(g.querySelectorAll('input[type="radio"]')),
        value: function () {
          if (sel) return sel.value;
          var c = g.querySelector('input[type="radio"]:checked');
          return c ? c.value : null;
        },
      };
    });
  }

  function buyable(variants, combo) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < combo.length; j++) {
        if (combo[j] !== null && v.options[j] !== combo[j]) { ok = false; break; }
      }
      if (ok) return !!v.available;
    }
    return false; // no such combination at all
  }

  function apply(vs, variants) {
    var gs = groups(vs);
    if (!gs.length) return;
    var current = gs.map(function (g) { return g.value(); });

    gs.forEach(function (g, idx) {
      g.inputs.forEach(function (input) {
        var combo = current.slice();
        combo[idx] = input.value;
        var ok = buyable(variants, combo);
        // Swatches and pills use different class names in Dawn.
        var cls = input.classList.contains('swatch-input__input') ? 'visually-disabled' : 'disabled';
        input.classList.toggle(cls, !ok);
      });

      if (g.select) {
        Array.prototype.forEach.call(g.select.options, function (opt) {
          var combo = current.slice();
          combo[idx] = opt.value;
          // A disabled <option> cannot be chosen at all, which is the same
          // dead end by a different route, so mark rather than disable.
          opt.classList.toggle('disabled', !buyable(variants, combo));
        });
      }
    });
  }

  function run() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var h = handle();
    if (!h) return;

    if (cache[h]) { apply(vs, cache[h]); return; }
    fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        cache[h] = p.variants;
        apply(vs, p.variants);
      })
      .catch(function () { /* leave Dawn's own marking in place */ });
  }

  function init() {
    run();

    // Dawn re-renders the picker on every change and wipes the marks with it,
    // so re-apply after its own handler has run rather than instead of it.
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('variant-selects')) setTimeout(run, 0);
    });

    // Section re-renders (Dawn swaps the whole picker) are not change events.
    var host = document.querySelector('.product__info-container') || document.body;
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; run(); }, 60);
      }).observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
